import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { CommonAPI } from "../../../axios/api";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  FormInputtext,
  FormInputnumber,
  FormDropdown,
} from "../../../components/formElement/index";
import { formatResData, checkFormUpdate } from "../../../service/common";
import { option_open } from "../../../service/option";
import { system_email } from "../../../service/system";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function CommonWarehousePopEdit(props) {
  const { closePrePop, prePopOption, setPreReload } = props;
  const dispatch = useDispatch();
  // 表單設定
  const defaultValues = {
    code: "",
    name: "",
    contact_name: "",
    contact_email: "",
    contact_phone: null,
    address1: "",
    address2: "",
    status: 1,
  };
  // 表單欄位驗證條件
  const [schema, setSchema] = useState(
    yup
      .object({
        code: yup.string().required("必填"),
        name: yup.string().required("必填"),
        // contact_name: yup.string().required("必填"),
        // contact_email: yup
        //   .string()
        //   .matches(system_email, {
        //     message: "電子郵件格式錯誤(ex:abc@gmail.com)",
        //     excludeEmptyString: true,
        //   })
        //   .required("必填"),
        // contact_phone: yup.string().required("必填").nullable(),
        // address1: yup.string().required("必填"),
        // address2: yup.string().required("必填"),
        status: yup.number().required("必填").nullable(),
      })
      .required()
  );
  const {
    control, // 將元件註冊至react-hook-form的方法
    formState: { errors, isSubmitted }, // 整個表單的狀態資料 (errors: 驗證錯誤的訊息)
    handleSubmit, // 表單被提交時觸發
    reset, // 重置表單(包含資料、狀態等等...)
    getValues, // 讀取資料
    setValue,
    trigger,
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  const [setting, setSetting] = useState({
    Controller,
    control,
    setValue,
    trigger,
    isSubmitted,
  });

  useEffect(() => {
    setSetting((state) => ({
      ...state,
      isSubmitted,
    }));
  }, [isSubmitted]);

  useEffect(() => {
    if (prePopOption.data) {
      reset(prePopOption.data);
    }
  }, [prePopOption]);

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    if (
      !checkFormUpdate({
        newData: submitData,
        oldData: prePopOption.data ?? {},
      })
    ) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      return;
    }

    let promise;
    if (prePopOption.data) {
      // 修改
      promise = CommonAPI.updateWarehouse({ data: submitData });
    } else {
      // 新增
      promise = CommonAPI.setWarehouse({ data: submitData });
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: "編輯成功",
            detail: "",
          })
        );
        closePrePop({ type: "edit" });
        setPreReload((state) => ({ ...state, list: true }));
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: message ?? "編輯失敗",
            detail: "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <div className="p-3">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid mx-0">
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="code"
              className={classNames(
                { "p-error": errors.code },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Code
            </label>
            <div className="col-12 sm:col-8">
              <FormInputtext setting={setting} data={{ name: "code" }} />
            </div>
          </div>
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="name"
              className={classNames(
                { "p-error": errors.name },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Name
            </label>
            <div className="col-12 sm:col-8">
              <FormInputtext setting={setting} data={{ name: "name" }} />
            </div>
          </div>
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="contact_name"
              className={classNames(
                { "p-error": errors.contact_name },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Contact Name
            </label>
            <div className="col-12 sm:col-8">
              <FormInputtext
                setting={setting}
                data={{ name: "contact_name" }}
              />
            </div>
          </div>
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="contact_phone"
              className={classNames(
                { "p-error": errors.contact_phone },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Contact Phone
            </label>
            <div className="col-12 sm:col-8">
              <FormInputnumber
                setting={setting}
                data={{ name: "contact_phone" }}
              />
            </div>
          </div>
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="contact_email"
              className={classNames(
                { "p-error": errors.contact_email },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Contact Email
            </label>
            <div className="col-12 sm:col-8">
              <FormInputtext
                setting={setting}
                data={{ name: "contact_email" }}
              />
            </div>
          </div>
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="address1"
              className={classNames(
                { "p-error": errors.address1 },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Address1
            </label>
            <div className="col-12 sm:col-8">
              <FormInputtext setting={setting} data={{ name: "address1" }} />
            </div>
          </div>
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="address2"
              className={classNames(
                { "p-error": errors.address2 },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Address2
            </label>
            <div className="col-12 sm:col-8">
              <FormInputtext setting={setting} data={{ name: "address2" }} />
            </div>
          </div>
          <div className="sm:flex sm:align-items-center field col-12">
            <label
              htmlFor="status"
              className={classNames(
                { "p-error": errors.status },
                "col-12 sm:col-4 sm:text-right sm:mb-0"
              )}
            >
              Status
            </label>
            <div className="col-12 sm:col-8">
              <FormDropdown
                setting={setting}
                data={{
                  name: "status",
                  options: option_open,
                  optionLabel: "label",
                  optionValue: "value",
                  showClear: false,
                }}
              />
            </div>
          </div>

          <div className="col-12 text-right">
            <Button
              type="button"
              label="Back"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => closePrePop({ type: "edit" })}
            />
            <Button type="submit" label="Save" className="ml-2 px-3" />
          </div>
        </form>
      </div>
    </>
  );
}
